import { prop } from 'ramda';
import { useMemo } from 'react';
import { getBaseDomain } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';

export const useOptions = (): SocketIOConnectOptions => {
    const openApiDomain = useAppSelector(prop('openApiDomain'));

    return useMemo(() => ({
        'request timeout': 30000,
        'reconnection delay': 3000,
        'max reconnection attempts': Infinity,
        'reconnection limit': 3000,
        'connect timeout': 15000,
        'force new connection': true,
        reconnect: true,
        transports: ['websocket', 'xhr-polling'],
        url: openApiDomain.replace('[superdomain]', getBaseDomain())
    }), [openApiDomain]);
};
